import _ from 'lodash';
import React, {FC} from 'react';

import {Renderer, RendererOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {isTeamNamespace} from '../../../../src/helpers/models/namespaceHelpers';
import {useAppSelector} from '../../../../src/helpers/reduxHelpers';
import {InboxModel} from '../../../../src/models/api/inboxModel';
import {getUserNamespace} from '../../../../src/store/data/teammates/teammatesSelectors';

/*
 * Props.
 */

export interface ConversationInboxesFormatterProps {
  conversationInboxes: ReadonlyArray<InboxModel>;
  renderDefault: Renderer;
  renderSingleInbox: RendererOf<InboxModel>;
  renderManyInboxes: RendererOf<ReadonlyArray<InboxModel>>;
}

/*
 * Component.
 */

export const ConversationInboxesFormatter: FC<ConversationInboxesFormatterProps> = (props) => {
  const {conversationInboxes, renderDefault, renderManyInboxes, renderSingleInbox} = props;

  const userNamespace = useAppSelector(getUserNamespace);

  // Single inbox case
  if (conversationInboxes.length === 1) {
    const singleInbox = conversationInboxes[0];
    const isPersonalInbox = singleInbox.namespace === userNamespace;
    const isTeamInbox = isTeamNamespace(singleInbox.namespace);

    if (isPersonalInbox || isTeamInbox) {
      return <>{renderSingleInbox(singleInbox)}</>;
    }

    return <>{renderDefault()}</>;
  }

  // Multi inboxes case
  const [accessibleInboxes] = _.partition(conversationInboxes, (singleInbox) => {
    const isPersonalInbox = singleInbox.namespace === userNamespace;
    const isTeamInbox = isTeamNamespace(singleInbox.namespace);

    return isPersonalInbox || isTeamInbox;
  });

  if (accessibleInboxes.length === 1) {
    return <>{renderSingleInbox(accessibleInboxes[0])}</>;
  }

  if (accessibleInboxes.length === 0) {
    return <>{renderDefault()}</>;
  }

  return <>{renderManyInboxes(accessibleInboxes)}</>;
};
